const c = (n, o) => n.filter((r) => new Date(r.date).getMonth() === o), g = (n, o, r = 4) => {
  if (r <= 0)
    return [];
  const l = (e, a) => new Date(e, a + 1, 0).getDate(), s = (e, a) => (new Date(e, a, 1).getDay() + 6) % 7;
  let t = n.getMonth(), i = n.getFullYear();
  return Array.from({ length: r }, () => {
    const e = c(
      o,
      t
    ), a = {
      month: t,
      year: i,
      days: l(i, t),
      previousDays: s(i, t),
      availabilities: e
    };
    return t++, t === 12 && (t = 0, i++), a;
  });
};
export {
  g as generateMonths
};
